<template>
  <section class="slider__area p-relative">
    <div class="slider__wrapper swiper-container">
      <swiper ref="mySwiper" :modules="modules" :effect="'fade'" :loop="true" :autoplay="{ delay: 5000 }">

        <swiper-slide>
          <div class="single-slider swiper-slide slider__height slider__overlay d-flex align-items-center"
            :style="{ background: 'url(' + require(`@/assets/img/slider/slider-4.jpg`) + ')' }">
            <div class="container">
              <div class="row">
                <div class="col-xxl-7 col-xl-8 col-lg-9 col-md-9 col-sm-10">
                  <div class="slider__content">
                    <span>Da graduação ao futuro</span>
                    <h3 class="slider__title">Nossa <span class="yellow-bg">caminhada <img
                          src="../../assets/img/shape/yellow-bg.png" alt=""> </span> não acaba com sua diplomação!
                    </h3>
                    <p>O sucesso de nossos egressos expressam nosso êxito enquanto instituição formadora, e por isso a
                      UFDPar busca manter com você um relacionamento contínuo e vivo.</p>
                    <button class="e-btn slider__btn" @click="$emit('scroll-to-why')">
                      Leia mais
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>

      </swiper>
    </div>

    <div class="row g-0">
      <div v-for="item in sliderNavData" :key="item.id" class="d-none d-md-block col-md-6 col-lg-3">
        <div :class="`slider__nav-item swiper-slide ${item.bgColor}`" :style="{ background: 'url(' + item.img + ')' }">
          <div class="slider__nav-content">
            <span>{{ item.title }}</span>
            <h4>{{ item.subtitle }}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, EffectFade, Autoplay } from "swiper";

export default {
  name: "HeroSlider",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      sliderData: [
        // {
        //   id: 1,
        //   img: require(`@/assets/img/slider/slider-4.jpg`),
        //   title:
        //     '',
        // },       
      ],
      sliderNavData: [
        {
          id: 1,
          img: require(`@/assets/img/slider/nav/colacao-ufdpar-1.jpg`),
          // title: "",
          // subtitle: "",
          bgColor: "orange-bg",
        },
        {
          id: 2,
          img: require(`@/assets/img/slider/nav/colacao-ufdpar-6.jpg`),
          // title: "",
          // subtitle: "",
          bgColor: "blue-bg",
        },
        {
          id: 3,
          img: require(`@/assets/img/slider/nav/colacao-ufdpar-3.jpg`),
          // title: "",
          // subtitle: "",
          bgColor: "pink-bg",
        },
        {
          id: 4,
          img: require(`@/assets/img/slider/nav/colacao-ufdpar-2.jpg`),
          // title: "",
          // subtitle: "",
          bgColor: "green-bg",
        },
      ],
    };
  },
  setup() {
    return {
      modules: [Navigation, EffectFade, Autoplay],
    };
  },
};
</script>
